<div [class]="classObject" class="zwi-content">
  <ng-content></ng-content>
</div>
